// extracted by mini-css-extract-plugin
module.exports = {"chipsContainer":"FilterChips_chipsContainer__XHYgM","chipsRow":"FilterChips_chipsRow__utZws","chip":"FilterChips_chip__ktJq6"};